import { useTranslation } from "react-i18next";
import ind1 from "../assests/solutions/ind-1.jpg";
import ind1ar from "../assests/solutions/ind-1ar.jpg";

import ind2 from "../assests/solutions/ind-2.webp";
import ind2ar from "../assests/solutions/ind-2ar.jpg";
import bg from "../assests/solutions/cloud-9.jpeg"
import './Industrial.css'
import { FiMessageSquare, FiBarChart2, FiSettings, FiTrendingUp, FiGitMerge, FiHeadphones, FiMonitor } from "react-icons/fi";
import Approach from "./Approach";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";
const Industrial = () => {

    const { i18n } = useTranslation();
    const isArabic = i18n.language === "ar";
    const approachItems = [
        {
            step: 1,
            title: "Assessment",
            description: "Strategic assessment and feasibility study",
        },
        {
            step: 2,
            title: "Plan",
            description: "Implementation plan for phase-wise implementation",
        },
        {
            step: 3,
            title: "Proof of value",
            description: "POC/POV to develop and provide a prototype for measurable impact",
        },
        {
            step: 4,
            title: "Pilot",
            description: "Phase-wise strategic rollout for ongoing assessment",
        },
        {
            step: 5,
            title: "Scale",
            description: "At scale deployment for full rollout and implementation",
        },

    ];

    return (
        <>
            <div className="hd">
                <Header />
            </div>
            <section
                className="main-hero"
                style={{
                    backgroundImage: `url(${isArabic ? ind1ar : ind1})`
                }}


            >
                <div className="main-overlay" />

                <div className="main-hero-content" data-aos="fade-up" style={{ paddingLeft: isArabic ? "0px" : "70px", paddingRight: isArabic ? "70px" : "0px" }}>
                    <h1 className="main-title">
                        Industrial IOT
                    </h1>

                    <p className="main-subtitle">
                        Unleash the power of connectivity to accelerate business success

                    </p>
                </div>

            </section>

            <section
                className="cloud-info-bg"
                style={{
                    backgroundImage: `url(${isArabic ? ind2ar : ind2})`
                }}
            >
                <div className="cloud-info-overlay" />

                <div className="cloud-info-content" data-aos="fade-up" style={{ paddingLeft: isArabic ? "0px" : "70px", paddingRight: isArabic ? "70px" : "0px" }}>
                    <p>TTH's IoT services help businesses in connecting assets and leveraging the power of IoT to improve productivity, derive real-time insights, reduce costs and drive innovation.</p>
                    <p>Our end-to-end IoT services revolutionize the way businesses operate. From assisting organizations to connect, monitor and optimize their devices to generating actionable insights,we help them transform their business and earn a competitive edge.</p>
                </div>
            </section>

            {/* <section className="manufacturing-benefits" data-aos="fade-up">
                <div className="container">
                    <div className="benefits-grid mt-5">

                        <div className="benefit-card">
                            <FiEye className="benefit-icon" />
                            <p>{t("man_benefit_1")}</p>
                        </div>

                        <div className="benefit-card">
                            <FiAlertTriangle className="benefit-icon" />
                            <p>{t("man_benefit_2")}</p>
                        </div>

                        <div className="benefit-card">
                            <FiCheckSquare className="benefit-icon" />
                            <p>{t("man_benefit_3")}</p>
                        </div>

                        <div className="benefit-card">
                            <FiSettings className="benefit-icon" />
                            <p>{t("man_benefit_4")}</p>
                        </div>

                        <div className="benefit-card">
                            <FiBarChart2 className="benefit-icon" />
                            <p>{t("man_benefit_5")}</p>
                        </div>

                        <div className="benefit-card">
                            <FiTrendingUp className="benefit-icon" />
                            <p>{t("man_benefit_6")}</p>
                        </div>

                    </div>
                </div>
            </section> */}

            <section className="iot-services-section">
                <div className="container">
                    <h2 className="iot-services-title" data-aos="fade-up">
                       TTH's comprehensive suite of IoT services help organizations in:
                    </h2>

                    <div className="iot-services-grid">
                        <div className="iot-service-card" data-aos="fade-up">
                            <FiMessageSquare className="iot-icon" />
                            <p>Consulting and solution development</p>
                        </div>

                        <div className="iot-service-card" data-aos="fade-up" data-aos-delay="100">
                            <FiBarChart2 className="iot-icon" />
                            <p>Analyzing collected data</p>
                        </div>

                        <div className="iot-service-card" data-aos="fade-up" data-aos-delay="200">
                            <FiSettings className="iot-icon" />
                            <p>Integrating business processes</p>
                        </div>

                        <div className="iot-service-card" data-aos="fade-up" data-aos-delay="300">
                            <FiTrendingUp className="iot-icon" />
                            <p>Improving decision making</p>
                        </div>
                    </div>
                </div>
            </section>


            <Approach
                title="Approach"
                data-aos="fade-up"
                backgroundImage={bg}
                items={approachItems}
            />

            {/* <section className="container">
                <div className="man_services-section">
                    <h2 className="man_services-title" data-aos="fade-up">
                        {t("man_services_title")}
                    </h2>

                    <div className="row">
                        <div className="col-md-6">
                            <ul className="man_services-list" data-aos="fade-right">
                                <li>{t("man_service_item_1")}</li>
                                <li>{t("man_service_item_2")}</li>
                                <li>{t("man_service_item_3")}</li>
                            </ul>
                        </div>

                        <div className="col-md-6">
                            <ul className="man_services-list " data-aos="fade-left">
                                <li>{t("man_service_item_4")}</li>
                                <li>{t("man_service_item_5")}</li>
                                <li>{t("man_service_item_6")}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section> */}


            <section className="iot-capabilities-section">
                <div className="container">

                    <h2 className="iot-capabilities-title" data-aos="fade-up">
                        Our IoT Capabilities include:
                    </h2>

                    <p className="iot-capabilities-subtitle" data-aos="fade-up">
                        We help our customers solve their toughest challenges by leveraging the power of IoT.
                    </p>

                    {/* SINGLE GRID */}
                    <div className="iot-capabilities-grid">

                        <div className="iot-cap-card" data-aos="fade-up">
                             <span className="cap-number">01</span>
                            <FiMonitor className="iot-cap-icon" />
                            <h4>Remote Monitoring</h4>
                            <p>Connecting machines and accessing real-time data</p>
                        </div>

                        <div className="iot-cap-card" data-aos="fade-up" data-aos-delay="100">
                             <span className="cap-number">02</span>
                            <FiBarChart2 className="iot-cap-icon" />
                            <h4>Data Analytics</h4>
                            <p>Analyzing real-time data to carry out in formed business decisions</p>
                        </div>

                        <div className="iot-cap-card" data-aos="fade-up" data-aos-delay="200">
                             <span className="cap-number">03</span>
                            <FiSettings className="iot-cap-icon" />
                            <h4>Predictive Maintenance</h4>
                            <p>Increasing equipment uptime and improving overall efficiency by carrying out predictive maintenance of machines and systems</p>
                        </div>

                        <div className="iot-cap-card" data-aos="fade-up">
                             <span className="cap-number">04</span>
                            <FiGitMerge className="iot-cap-icon" />
                            <h4>Integration with other systems</h4>
                            <p>Streamlined integration with existing systems with minimal disruption to operations</p>
                        </div>

                        <div className="iot-cap-card" data-aos="fade-up" data-aos-delay="100">
                             <span className="cap-number">05</span>
                            <FiHeadphones className="iot-cap-icon" />
                            <h4>Support</h4>
                            <p>Dedicated team of experts to assist you in your IoT journey</p>
                        </div>

                    </div>

                </div>
            </section>


            <Footer />

        </>
    );
};

export default Industrial;